import { parse } from "content-disposition-header";

const DEFAULT_DOWNLOAD_FILENAME = "download.txt";

function getResponseFilename(response: Response, fallbackFilename: string): string {
  const contentDisposition = response.headers.get("Content-Disposition");
  if (!contentDisposition) {
    return fallbackFilename;
  }

  const parsedContentDisposition = parse(contentDisposition);
  return parsedContentDisposition.parameters.filename || fallbackFilename;
}

export async function downloadResponseFile(
  response: Response,
  fallbackFilename: string = DEFAULT_DOWNLOAD_FILENAME
): Promise<void> {
  if (!response.ok) {
    return;
  }

  const objectUrl = window.URL.createObjectURL(await response.blob());
  const anchor = document.createElement("a");
  anchor.href = objectUrl;
  anchor.download = getResponseFilename(response, fallbackFilename);
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  window.URL.revokeObjectURL(objectUrl);
}
